import React, { useContext } from 'react';
// IMPORT withRouter THAY VÌ CÁC HOOKS CỦA ROUTER
import { docTrangThaiMoBaoCao } from './moBaoCaoTuDashboard';
import { withRouter, Redirect } from 'react-router-dom'; 
import { Box, Typography, Button, CircularProgress } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

import { useQuery } from '@tanstack/react-query';
import DataListManager from './DataListManager';
import ReportFrame from "./ReportFrame";
import DynamicCustomPage from "./DynamicCustomPage";
import AuthContext from "./auth/Context";
import Helmet from 'react-helmet';

// =====================================================================
// BỘ CHUYỂN ĐỔI 1: Dịch cấu hình Server (Legacy Report) sang Cấu hình mới
// =====================================================================
import { HOOK_ARGS, VALUE_CHANGED_ARGS, VALUE_CHANGED_ARGS_LEGACY } from './lifecycleHooks';
import { adaptListinfoFields } from './adaptListinfoFields';
import { adaptListinfoConfig, collectDetailFormCodes, unsupportedKeys, parseSort } from './adaptListinfoConfig';
import { resolveFormSize } from './voucherFormTabs';
import { applyGridConfigs } from './gridConfigs';
import { defaultScriptBody } from './fieldDefaults';
import { runListinfoScript, adaptListinfoProps } from './listinfoProps';
import { chayHeaderScript } from './listinfoHeaderScript';
import Moment from 'moment';
import * as utils from '../utils';

const AsyncFunction = Object.getPrototypeOf(async function(){}).constructor;

const parseColumnConfig = (config)=>{
  if(!config) return null;
  try{
    let fnstirng = config;
    if(!fnstirng.includes("return")){
      fnstirng = `return ${fnstirng}`
    }
    const fn = new Function(fnstirng);
    return fn();
  }catch(e){
    console.error(e,config);
  }
}

export const adaptLegacyReportConfig = async (oldConfig, context) => {
  if (!oldConfig) return null;

  const has_title = (oldConfig.columns || []).find(d=>d.is_title || d.isTitle) || (oldConfig.columns || []).find(d=>d.field=="ten_kh" || d.field=="ten_vt" || d.field=="ten_tk" || d.field=="ten_nv" || d.field=="ten_bp" || d.field=="chi_tieu");
  const has_sub_title = (oldConfig.columns || []).find(d=>d.is_sub_title || d.isSubTitle) || (oldConfig.columns || []).find(d=>d.field=="ma_kh" || d.field=="ma_vt" || d.field=="tk" || d.field=="ma_nv" || d.field=="ma_bp" || d.field=="ma_so");

  const displayFields = (oldConfig.columns || []).map((col, index) => ({
    field: col.field,
    label: col.header,
    type: col.datatype=="Pivot"?"Number": (col.datatype || 'String'),
    hide: col.hide,
    config: parseColumnConfig(col.config),
    custom_header:col.custom_header,
    custom_render:col.custom_render,
    handle_click:col.handle_click,
    subColumns:col.datatype=="Pivot"?{
        data:col.field,
        code_field:col.pivot_code_field,
        code_label:col.pivot_code_label,
    }:null,
    hide_with_condition:col.hide_with_condition,
    isTitle: col.is_title || col.isTitle || has_title?.field==col.field || (!has_title && index==1),      
    isSubTitle: col.is_sub_title || col.isSubTitle || has_sub_title?.field==col.field || (!has_sub_title && index==0),   
  }));
  
  const filterFields = [];
  let hasTuNgay = false, hasDenNgay = false;
  
  const oldFilters = oldConfig.filterFields || [];
  oldFilters.forEach(f => {
     if (f.name === 'tu_ngay') hasTuNgay = true;
     if (f.name === 'den_ngay') hasDenNgay = true;
  });

  if (hasTuNgay && hasDenNgay) {
     filterFields.push({
        field: 'ky_bao_cao',
        label: 'Thời gian báo cáo',
        type: 'DateFilter',
        mapTo: ['tu_ngay', 'den_ngay'],
        required: true,
        default: { type: 'thisMonth' } 
     });
  }

  for (const f of oldFilters) {
     if ((f.name === 'tu_ngay' || f.name === 'den_ngay') && hasTuNgay && hasDenNgay) continue;

     let finalLabel = f.header;
     
     if (typeof f.header === 'string' && (f.header.includes('return ') || f.header.includes('await '))) {
        try {
           const mockLegacyAPI = {
               asyncGetData: async (token, model, condition) => {
                   const res = await context.apis.asyncGetList(token, model, { condition, limit: 1 });
                   return res?.data?.[0] || res?.[0] || null;
               }
           };

           const dynamicLabelFunc = new AsyncFunction("API", "context", f.header);
           finalLabel = await dynamicLabelFunc(mockLegacyAPI, context);
           
        } catch (e) {
           console.warn(`Lỗi khi chạy script label của trường ${f.name}:`, e);
           finalLabel = "Lọc dữ liệu"; 
        }
     }

     let fieldType = f.type;
     let customConfig = {}; 
     let parsedDefault = f.default;

     if (f.ref_model) {
        let isStaticArray = false;
        let parsedOptions = [];

        if (typeof f.ref_model === 'string') {
           const strRef = f.ref_model.trim();
           if (strRef.startsWith('[')) {
              try {
                 parsedOptions = (new Function("return " + strRef))();
                 isStaticArray = Array.isArray(parsedOptions);
              } catch (e) {}
           } else if (strRef.includes(',')) {
              parsedOptions = strRef.split(',').map(item => {
                 const val = item.trim();
                 return { code: val, name: val }; 
              });
              isStaticArray = true;
              f.ref_field = f.ref_field || "code";
              f.ref_label = f.ref_label || "name";
           }
        }

        if (isStaticArray) {
           fieldType = 'Select'; 
           if (typeof parsedDefault === 'string' && parsedDefault.trim().startsWith('[')) {
              try { parsedDefault = (new Function("return " + parsedDefault))(); } catch (e) {}
           }
           customConfig = {
              multiple: f.multiple || false,
              options: parsedOptions.map(opt => ({
                 value: opt[f.ref_field || "value"],
                 label: opt[f.ref_label || "name"]
              }))
           };
        } else {
           fieldType = 'Autocomplete'; 
           customConfig = {
              multiple: f.multiple || false, 
              api: f.ref_model,
              canQuickAdd:f.canAdd || f.ref_model.startsWith("rptform"),
              apiMapping: {
                 value: f.ref_field || "_id", 
                 label: f.ref_label || "name", 
                 ...(f.ref_label_as && { label_as: f.ref_label_as }) 
              }
           };
           if (f.ref_condition) {
              try { customConfig.apiCondition = JSON.parse(f.ref_condition); } 
              catch (e) { customConfig.apiCondition = f.ref_condition; }
           }
        }
     }
     if(f.not_input){
      let  str_function = f.not_input;
      if(str_function.indexOf("return ")<0) str_function = `return ${str_function}`;
      //console.log("[DataDynamicPage] [ReportFilter] tạo hideInForm function",str_function,f);
      f.hideInForm = function(context,formData){
        let func =  new Function("context","formData","master", "detail","mediaQueryMatches",str_function);
        return func(context,formData,formData,formData,true);
      }
     }

     filterFields.push({
        field: f.name,
        label: finalLabel,
        type: fieldType,
        required: f.required,
        default: parsedDefault,
        hideInForm:f.hideInForm,
        ...customConfig 
     });
  }
  return {
    code: oldConfig.code,
    apiCode:oldConfig.api_code,
    title: oldConfig.title,
    searchLabel:oldConfig.search_label,
    cancelLabel:oldConfig.cancel_label,
    enableLoadMore: true,
    drillDownScript: oldConfig.drilldown_info,
    handleDataScript:oldConfig.handle_data,
    handleConditionScript:oldConfig.handle_condition,
    filterFields,
    displayFields
  };
};

// =====================================================================
// BỘ CHUYỂN ĐỔI 2: Dịch cấu hình JSON/Script từ Mongoose DataListConfig
// =====================================================================
export const parseDataListConfig = (config,context) => {
  // Lấy dữ liệu thuần (nếu là Mongoose Document thì lấy ._doc hoặc toObject)
  const rawData = config.toObject ? config.toObject() : (config._doc || config);
  rawData.code = rawData.code || rawData.moduleCode;

  //parse condition script (điều kiện lây dữ liệu)
  //console.log("[parseDataListConfig]",config);
  if(rawData.conditionScript){
    try{
      let str_function = rawData.conditionScript;
      if(str_function.indexOf("return ")<0){
        str_function = `return ${str_function}`
      }
      let func = new Function("context",str_function);
      rawData.conditionScript = func(context);
    }catch(e){
      console.error("[parseDataListConfig] lỗi parse conditionScript",e,rawData.conditionScript);
      rawData.conditionScript = {}
    }
  }

  // 1. DANH SÁCH CÁC TỪ KHÓA CẦN XỬ LÝ ĐẶC BIỆT
  // Các key chứa script cần được parse thành Function thực thi
  // `required` nhận thêm dạng SCRIPT (bắt buộc theo điều kiện, vd "return formData.ma_nt !== 'VND'") —
  // tương đương `required` dạng script của listinfo. Boolean vẫn chạy như cũ.
  // `editableInList` (cho sửa thẳng trên lưới danh sách) cũng nhận dạng SCRIPT, để cho sửa theo điều
  // kiện của TỪNG DÒNG: "return formData.trang_thai !== 'locked'".
  const FUNCTION_KEYS = ['hideInForm', 'hideInList', 'hideInView', 'apiConditionFn','helpText','readOnly','required','editableInList'];
  // BỘ SCRIPT VÒNG ĐỜI (tương đương expression_check_save / on_saved / on_deleting / on_deleted /
  // on_init / on_init_update / handle_cell_clicked của listinfo). Tất cả được phép `await`.
  // Tên tham số của từng hook lấy từ `lifecycleHooks.HOOK_ARGS` — gán ĐỦ CẢ tên của InputBase lẫn tên
  // của DataListManager, nên script cũ dán sang chạy nguyên si mà viết mới vẫn nhất quán.
  const LIFECYCLE_KEYS = Object.keys(HOOK_ARGS);
  // `listActionScript` = script của NÚT CHỨC NĂNG RIÊNG của danh sách (`listActions[]`), vd "Đồng bộ
  // bài viết" ở danh sách bài post. Biên dịch thành async function — gần như mọi nút như vậy đều gọi
  // máy chủ.
  // `searchCondition` = cách một ô của FORM TÌM KIẾM RIÊNG tự dịch sang điều kiện (← handle_search_condition):
  // script SỬA THẲNG vào `condition`, không return -> KHÔNG được bọc thành template như FUNCTION_KEYS.
  // `rowActionScript` = script của NÚT TUỲ CHỈNH TỪNG DÒNG (`rowActions[]`) ở cột Thao tác / màn hình xem — vd "Tạo cơ hội" của lead.
  const FUNCTION_ACTION_KEYS = ['actionScript','onValueChanged','listActionScript','rowActionScript','searchCondition', ...LIFECYCLE_KEYS];
  
  // Map tham số cho từng loại Function
  // Bổ sung `masterData` (dữ liệu form mẹ) làm tham số cuối cho mọi loại → script trong form con
  // có thể truy cập dữ liệu form mẹ. Thêm ở CUỐI nên tương thích ngược (script cũ không dùng vẫn chạy).
  // `fields` = danh sách TOÀN BỘ field của form hiện tại (mảng field config) → cho phép
  // script điều khiển UI kiểm tra sự tồn tại/thuộc tính của field khác (vd ẩn `ngay_ks`
  // nếu form không có field `ngay_ct`). Thêm ở cuối nên tương thích ngược.
  const FUNCTION_ARGS = {
    'apiConditionFn': ['formData', 'baseCondition', 'masterData', 'fields'],
    'actionScript': ['context','formData', 'history', 'masterData', 'fields'],
    // `goiRoute(sub, body)` gọi route riêng của CHÍNH danh sách này (`/<apiCode>/<sub>`) và ném lỗi
    // kèm câu của máy chủ khi `success === false` — đỡ cho mỗi script tự dựng URL, tự gắn token, tự
    // phân tích phản hồi (và tự quên kiểm lỗi).
    'listActionScript': ['context', 'goiRoute', 'condition', 'selectedIds', 'selectedItems', 'refresh', 'quickAction', 'history', 'code'],
    // PHẢI trùng THAM_SO_NUT_DONG (nutChucNangDanhSach.js).
    'rowActionScript': ['context', 'goiRoute', 'item', 'refresh', 'quickAction', 'history', 'code', 'apis', 'token'],
    // `handle_value_changed` của listinfo — gán ĐỦ CẢ HAI bộ tên (xem lifecycleHooks.VALUE_CHANGED_ARGS):
    // script cũ dùng `master`/`detail`/`data`/`value`/`ref_value`/`API`/`moment`/`numeral`, script mới
    // dùng `newValue`/`formData`/`optionObj`. Xem thêm phương án lùi ở `parseFunctionAction`.
    'onValueChanged': VALUE_CHANGED_ARGS,
    'searchCondition': ['condition', 'value', 'moment', 'numeral', 'formData', 'context'],
    ...HOOK_ARGS,
    'default': ['context', 'formData', 'masterData', 'fields']
  };

  // Các key TUYỆT ĐỐI KHÔNG ĐƯỢC PARSE (Giữ nguyên chuỗi Text React JSX)
  const IGNORE_PARSE_KEYS = ['customFormScript', 'customListScript'];

  // 2. CÁC HÀM PARSER CƠ SỞ
  const parseJSON = (val) => {
    if (typeof val === 'string') {
      const trimmed = val.trim();
      if (trimmed === 'true') return true;
      if (trimmed === 'false') return false;
      // Chỉ parse nếu thực sự có hình dáng của JSON Object hoặc Array
      if ((trimmed.startsWith('{') && trimmed.endsWith('}')) || 
          (trimmed.startsWith('[') && trimmed.endsWith(']'))) {
        try { return JSON.parse(trimmed); } catch (e) { return val; }
      }
    }
    return val;
  };

  const parseFunction = (val, key) => {
    if (typeof val !== 'string') return val;
    let trimmed = val.trim();
    if(!trimmed) return val;

    if (trimmed === 'true') return true;
    if (trimmed === 'false') return false;

    const args = FUNCTION_ARGS?.[key] || FUNCTION_ARGS?.['default'];
    try {
      if(trimmed.indexOf("return ")<0){
         trimmed = "return `" + trimmed + "`";
      }
      //console.log(`[Parser] Đang biên dịch Script Function [${key}]:`,trimmed,args);
      return new Function(...args, trimmed);
    } catch (e) {
      console.warn(`[Parser] Lỗi biên dịch Script Function [${key}]:`, e,trimmed);
      return val; // Lỗi thì trả về chuỗi gốc cho an toàn
    }
  };
  const AsyncFunction = Object.getPrototypeOf(async function () {}).constructor;
  const parseFunctionAction = (val, key) => {
    let trimmed = val.trim();
    if(!trimmed) return;
    const args = FUNCTION_ARGS?.[key] || FUNCTION_ARGS?.['default'];
    try {
      // onValueChanged và TOÀN BỘ script vòng đời cho phép `await` (gọi API lấy giá, đối chiếu tồn
      // kho, ghi nhật ký sau khi lưu…) → biên dịch thành async function.
      if (key === 'onValueChanged' || key === 'listActionScript' || key === 'rowActionScript' || LIFECYCLE_KEYS.includes(key)) return new AsyncFunction(...args, trimmed);
      return new Function(...args, trimmed);
    } catch (e) {
      // PHƯƠNG ÁN LÙI cho `onValueChanged`: bộ tên đầy đủ có thêm `data`, `value`, `master`… Một script
      // CŨ khai `const data = ...` trong thân sẽ thành "đã khai báo rồi" và không biên dịch được — mà
      // trước đây nó vẫn chạy. Thử lại với đúng bộ tên cũ để không giết cấu hình đang chạy.
      if (key === 'onValueChanged') {
        try {
          const fn = new AsyncFunction(...VALUE_CHANGED_ARGS_LEGACY, trimmed);
          console.warn(`[Parser] onValueChanged trùng tên biến với bộ tham số mới (${e.message}) -> chạy với bộ tên cũ; đổi tên biến trong script để dùng được master/detail/value/ref_value.`);
          // Bọc lại để bên gọi vẫn truyền theo bộ ĐẦY ĐỦ: lấy đúng các tham số cũ theo VỊ TRÍ trong bộ mới.
          const idx = VALUE_CHANGED_ARGS_LEGACY.map(n => VALUE_CHANGED_ARGS.indexOf(n));
          return (...all) => fn(...idx.map(i => (i >= 0 ? all[i] : undefined)));
        } catch (e2) { /* hỏng thật thì rơi xuống cảnh báo chung */ }
      }
      console.warn(`[Parser] Lỗi biên dịch Script Function [${key}]:`, e,trimmed);
      return; // Lỗi thì trả về chuỗi gốc cho an toàn
    }
  };

  // 3. THUẬT TOÁN ĐỆ QUY (RECURSIVE TRAVERSAL)
  const traverseAndParse = (data) => {
    // Nếu là Mảng -> Lặp qua từng phần tử và gọi đệ quy
    if (Array.isArray(data)) {
      return data.map(item => traverseAndParse(item));
    }
    
    // Nếu là Object (và không phải Date/ObjectId) -> Lặp qua từng Key
    if (data !== null && typeof data === 'object') {
      // Giữ nguyên các object đặc biệt của JS/Mongoose
      if (data instanceof Date || data._bsontype) return data;

      const result = {};
      for (const key in data) {
        if (!data.hasOwnProperty(key)) continue;
        
        let val = data[key];

        // Trường hợp 1: Bỏ qua các key JSX Script (Custom Form/List)
        if (IGNORE_PARSE_KEYS.includes(key)) {
          result[key] = val;
        }
        // Trường hợp 2: Chuyển đổi thành Function thực thi
        else if (FUNCTION_KEYS.includes(key)) {
          result[key] = parseFunction(val, key);
        }
        else if (FUNCTION_ACTION_KEYS.includes(key) && val && typeof(val)=="string") {
          result[key] = parseFunctionAction(val, key);
        }
        // Trường hợp 3: Nếu là chuỗi, thử parse JSON
        else if (typeof val === 'string') {
          const parsedVal = parseJSON(val);
          
          // NẾU PARSE THÀNH CÔNG RA OBJECT/ARRAY -> ĐỆ QUY TIẾP VÀO BÊN TRONG NÓ
          if (parsedVal !== val && typeof parsedVal === 'object' && parsedVal !== null) {
            result[key] = traverseAndParse(parsedVal);
          } else {
            result[key] = parsedVal; // Là boolean, number, hoặc chuỗi thường
          }
        }
        // Trường hợp 4: Nếu vốn dĩ đã là Object/Array lồng nhau -> Đệ quy đi xuống
        else {
          result[key] = traverseAndParse(val);
        }
      }
      return result;
    }
    
    // Trả về các giá trị nguyên thuỷ (Number, Boolean, null, String không parse được)
    return data;
  };

  // Bắt đầu quét từ gốc của Object
  return traverseAndParse(rawData);
};

// =====================================================================
// BỘ CHUYỂN ĐỔI 3: listinfo (bộ cũ) -> cấu hình DataListManager
// ---------------------------------------------------------------------
// Cùng vai trò với adaptLegacyReportConfig bên báo cáo. Bất đồng bộ vì lưới chi tiết của chứng từ khai
// `type: 'Array'` + `form` = MÃ listinfo CON, phải nạp thêm listinfo con mới dựng được subFields.
// =====================================================================
/**
 * NẠP CẤU HÌNH DANH SÁCH của một module — `data_list_config` trước, `listinfo` sau.
 *
 * VÌ SAO LÀ MỘT HÀM DÙNG CHUNG: `DataListManager` KHÔNG tự đi tìm cấu hình của nó; ai dựng nó thì
 * người đó phải đưa `fields` vào. Trang đầy đủ (`/page/list/<code>`) làm việc đó, còn widget danh
 * sách trên dashboard thì trước đây không — nó chỉ truyền `{code, condition}`. Kết quả là
 * `fields` rỗng: danh sách rơi về nhãn mặc định "Bản ghi #N", và form mở ra không có ô nào để vẽ.
 * Nhìn như "dữ liệu hỏng" trong khi dữ liệu vẫn đủ.
 *
 * Gom về một hàm để hai nơi không thể hiểu khác nhau — hai cách nạp cấu hình song song là cách
 * chắc chắn nhất để cùng một module hiện một kiểu ở trang và một kiểu ở widget.
 *
 * Trả `null` khi module không có cả hai loại cấu hình.
 */
export const napCauHinhDanhSach = async ({ code, type = "list", context, userToken, tho = false }) => {
  if (!code || !userToken || !context?.apis) return null;
  // 1) ƯU TIÊN model MỚI `data_list_config` — đã là định dạng mới, dùng thẳng.
  const res = await context.apis.asyncGetList(userToken, "data_list_config", { condition: { moduleCode: code }, limit: 1 });
  let item = res?.data?.[0] || res?.[0];
  const source = item ? 'data_list_config' : 'listinfo';

  // 2) FALLBACK model CŨ `listinfo` — dựng giao diện thẳng từ khai báo cũ, khỏi phải tạo thêm bản
  //    ghi data_list_config cho từng công ty. Đúng mẫu reportconfig -> reportinfo bên báo cáo.
  //    Route CŨ `/list/<code>` và `/voucher/<code>` KHÔNG đi qua đây, vẫn chạy InputBase như cũ.
  if (!item) {
    try {
      const resLi = await context.apis.asyncGetList(userToken, "listinfo", { condition: { code }, limit: 1 });
      const li = resLi?.data?.[0] || resLi?.[0];
      if (li) item = await adaptListinfoToDataList(li, context, userToken, type);
    } catch (e) {
      console.warn("[napCauHinhDanhSach] không nạp được listinfo:", e?.message || e);
    }
  }

  if (!item) return null;
  // `tho`: trả cấu hình THÔ (script còn là chuỗi) kèm nguồn — cho nút "Cấu hình màn hình": màn hình
  // đang chạy từ listinfo thì bản dịch thô là BẢN NHÁP để tạo data_list_config (hàm đã biên dịch thì
  // không lưu xuống DB được).
  if (tho) return { source, item };
  return parseDataListConfig(item, context);
};

export const adaptListinfoToDataList = async (listinfo, context, userToken, pageType) => {
  if (!listinfo) return null;
  const liGoc = listinfo.toObject ? listinfo.toObject() : (listinfo._doc || listinfo);
  // `header` dạng SCRIPT phải CHẠY trước khi dịch — không thì nhãn cột/ô là nguyên đoạn mã. Tạo bản sao,
  // không sửa object listinfo đang nằm trong cache của react-query.
  const li = { ...liGoc, fields: await chayHeaderScript(liGoc.fields || [], liGoc, context) };

  // Nạp listinfo CON cho các lưới chi tiết. Thiếu bước này thì chứng từ ra màn hình KHÔNG có dòng chi
  // tiết nào — mà chẳng có lỗi gì, vì ObjectArray không subFields vẫn vẽ được một lưới rỗng.
  // MỘT bộ deps dùng chung: thiếu `applyGridConfigs` ở bất kỳ lời gọi nào là field ở đó mất sạch
  // grid_configs (cỡ ô, readOnly, format) mà không có lỗi nào.
  const adaptDeps = { adaptListinfoFields, resolveFormSize, applyGridConfigs, defaultScriptBody };

  const detailFieldsByForm = {};
  const detailCodes = collectDetailFormCodes(li, adaptDeps);
  if (detailCodes.length) {
    try {
      const res = await context.apis.asyncGetList(userToken, "listinfo", {
        condition: { code: { $in: detailCodes } }, limit: detailCodes.length,
      });
      for (const child of (res?.data || res || [])) {
        const c0 = child.toObject ? child.toObject() : (child._doc || child);
        // Cột của lưới chi tiết cũng có thể khai nhãn bằng script — chạy trên BẢN SAO.
        const c = c0 ? { ...c0, fields: await chayHeaderScript(c0.fields || [], c0, context) } : c0;
        if (c && c.code) detailFieldsByForm[c.code] = adaptListinfoFields(c.fields || [], {}, adaptDeps);
      }
    } catch (e) {
      console.warn("[DataDynamicPage] không nạp được listinfo con của lưới chi tiết:", e?.message || e);
    }
    for (const missing of detailCodes.filter(c => !detailFieldsByForm[c])) {
      console.warn(`[DataDynamicPage] listinfo "${li.code}": không tìm thấy listinfo con "${missing}" -> lưới chi tiết sẽ rỗng.`);
    }
  }

  const missing = unsupportedKeys(li);
  if (missing.length) {
    console.warn(`[DataDynamicPage] listinfo "${li.code}" có khai ${missing.join(', ')} — bộ giao diện mới CHƯA hỗ trợ, phần đó sẽ không hiện.`);
  }

  const gridReport = [];
  const config = adaptListinfoConfig(li, adaptDeps, { detailFieldsByForm, pageType, gridReport });

  // ---------------------------------------------------------------------
  // `options.props` — SCRIPT trả về object thuộc tính, THẮNG khai báo cấp listinfo (đúng như
  // `InputBase.getProps`). Chạy ở đây chứ không ở `parseDataListConfig` vì script được phép `await`
  // (gọi API lấy danh mục, tính kỳ theo Moment) và cần đủ `Moment/API/utils/context/listInfo`.
  // ---------------------------------------------------------------------
  const scriptDeps = { Moment, utils };
  const scriptArgs = { context, listInfo: li };
  const rawProps = li.options && li.options.props;
  if (rawProps) {
    const run = await runListinfoScript(rawProps, scriptArgs, scriptDeps);
    if (!run.ok) {
      console.error(`[DataDynamicPage] listinfo "${li.code}": options.props chạy lỗi (${run.error}) -> bỏ qua toàn bộ.`, rawProps);
    } else if (run.value && typeof run.value === 'object') {
      const p = adaptListinfoProps(run.value, li, { parseSort });
      Object.assign(config, p.config);
      if (Object.keys(p.condition).length) config.condition = { ...(config.condition || {}), ...p.condition };
      if (p.ignored.length) {
        console.warn(`[DataDynamicPage] listinfo "${li.code}": options.props có ${p.ignored.join(', ')} — bộ giao diện mới CHƯA hỗ trợ, phần đó sẽ không có tác dụng.`);
      }
    } else {
      console.warn(`[DataDynamicPage] listinfo "${li.code}": options.props không trả về object -> bỏ qua.`, run.value);
    }
  }
  // `options.form_full_screen` nằm NGOÀI props (cùng cấp với nó) nhưng cùng ý nghĩa.
  if (li.options && li.options.form_full_screen === true) config.formSize = 'full';

  // ---------------------------------------------------------------------
  // `default_condition` cũng là SCRIPT cùng phương ngữ (`InputBase.getDefaultConditon`), được phép
  // `await` và dùng `Moment/API/utils`. `parseDataListConfig` chỉ biên dịch với `context` và chạy đồng
  // bộ, nên chạy ở đây rồi cất kết quả vào `condition`; sai ở đây là màn hình lọc bằng object rác.
  // ---------------------------------------------------------------------
  if (config.conditionScript) {
    const run = await runListinfoScript(config.conditionScript, scriptArgs, scriptDeps);
    delete config.conditionScript;
    if (!run.ok) {
      console.error(`[DataDynamicPage] listinfo "${li.code}": default_condition chạy lỗi (${run.error}) -> KHÔNG áp điều kiện nào.`, li.default_condition);
    } else if (run.value && typeof run.value === 'object') {
      config.condition = { ...(config.condition || {}), ...run.value };
    } else {
      console.warn(`[DataDynamicPage] listinfo "${li.code}": default_condition không trả về object -> bỏ qua.`, run.value);
    }
  }

  // Báo ra những gì grid_configs KHÔNG mang sang được — im lặng bỏ qua là người khai báo tưởng đã khai xong.
  for (const r of gridReport) {
    if (r.error) console.warn(`[DataDynamicPage] listinfo "${li.code}" field "${r.field}": grid_configs đọc không được (${r.error}) -> bỏ qua.`);
    if (r.dynamic) console.info(`[DataDynamicPage] listinfo "${li.code}" field "${r.field}": grid_configs phụ thuộc dữ liệu — đã lấy cỡ ô bằng cách chạy với data rỗng (${r.applied.join(', ') || 'không có gì'}); cỡ ô có thể khác khi dữ liệu khác.`);
    if (r.skipped.length) console.warn(`[DataDynamicPage] listinfo "${li.code}" field "${r.field}": grid_configs bỏ qua ${r.skipped.join(', ')} (giá trị không hợp lệ, hoặc field đã khai tường minh khoá đó).`);
    if (!r.dynamic && r.ignored.length) console.warn(`[DataDynamicPage] listinfo "${li.code}" field "${r.field}": bộ giao diện mới chưa hỗ trợ grid_configs.${r.ignored.join('/')}.`);
  }
  console.log(listinfo.code,config);
  return config;
};

// =====================================================================
// COMPONENT DYNAMIC PAGE RENDER
// =====================================================================
const DynamicPageRender = (props) => {
  const { match, location, history } = props;
  const type = match?.params?.type;
  const code = match?.params?.code;
  
  const context = useContext(AuthContext);

  const userToken = context.userInfo?.token || (typeof context.getToken === 'function' ? context.getToken() : '');
  const stateCondition = location.state?.condition || {};
  //console.log("[DynamicPage] stateCondition",stateCondition);

  // =====================================================================
  // BƯỚC 1: TÌM CẤU HÌNH Ở LOCAL (Context)
  // =====================================================================
  let pageConfig;
  if (type === "report") {
    pageConfig = context.config?.getReportConfig(code);
  } else {
    pageConfig = context.config?.getPageConfig(code);
  }

  // =====================================================================
  // BƯỚC 2A: TÌM CẤU HÌNH REPORT TRÊN SERVER
  // =====================================================================
  const { data: fetchedReportConfig, isLoading: isReportLoading } = useQuery({
    queryKey: ['reportInfo_config', code],
    queryFn: async () => {
      // 1) ƯU TIÊN model MỚI `reportconfig` — đã là ĐỊNH DẠNG MỚI (displayFields/filterFields/…)
      //    nên dùng THẲNG, KHÔNG cần adaptLegacyReportConfig.
      try {
        const resNew = await context.apis.asyncGetList(userToken, "reportconfig", { condition: { code }, limit: 1 });
        const itemNew = resNew?.data?.[0] || resNew?.[0];
        if (itemNew) {
          return itemNew.toObject ? itemNew.toObject() : (itemNew._doc || itemNew);
        }
      } catch (e) {
        // reportconfig có thể chưa tồn tại ở một số hệ thống -> bỏ qua, fallback reportinfo
        console.warn("[DataDynamicPage] reportconfig không khả dụng, fallback reportinfo:", e?.message || e);
      }

      // 2) FALLBACK model CŨ `reportinfo` — nếu là bản legacy (`columns` mà chưa có `displayFields`)
      //    thì dịch sang định dạng mới.
      const res = await context.apis.asyncGetList(userToken, "reportinfo", { condition: { code }, limit: 1 });
      let item = res?.data?.[0] || res?.[0];
      if (!item) return null;

      if (item.columns && !item.displayFields) {
         item = await adaptLegacyReportConfig(item, context);
      }
      return item;
    },
    enabled: !pageConfig && !!code && !!userToken && type === "report",
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false
  });

  // =====================================================================
  // BƯỚC 2B: TÌM CẤU HÌNH DATALIST TRÊN SERVER (TÍNH NĂNG MỚI NÂNG CẤP)
  // =====================================================================
  const { data: fetchedDataListConfig, isLoading: isDataListLoading } = useQuery({
    queryKey: ['dataList_config', code],
    queryFn: async () => napCauHinhDanhSach({ code, type, context, userToken }),
    // Chạy khi: Không có config ở Local VÀ không phải report/custom (custom có luồng riêng)
    enabled: !pageConfig && !!code && !!userToken && type !== "report" && type !== "custom",
    staleTime: 5 * 60 * 1000, 
    refetchOnWindowFocus: false 
  });

  // Hợp nhất kết quả từ 3 nguồn
  const finalPageConfig = pageConfig || fetchedReportConfig || fetchedDataListConfig;
  const isAnyLoading = isReportLoading || isDataListLoading;
  const finalTitle = finalPageConfig?.title || finalPageConfig?.name || context.config?.app_name || context.config?.app_title || "Flexbiz"; 

  // =====================================================================
  // BƯỚC 3: GIAO DIỆN CHỜ (LOADING)
  // =====================================================================
  if (isAnyLoading) {
    return (
      <Box sx={{ height: '100dvh', display: 'flex', justifyContent: 'center', alignItems: 'center', bgcolor: '#f2f2f7' }}>
        <CircularProgress size={40} thickness={4} sx={{ color: 'text.secondary' }} />
      </Box>
    );
  }

  // =====================================================================
  // BƯỚC 3B: TRANG TUỲ BIẾN (custom) — usermodule ship component React qua 'custompage'
  // =====================================================================
  if (type === "custom") {
    return <>
      <Helmet title={`${finalTitle} - ${context.appInfo?.name || ""}`} />
      <DynamicCustomPage code={code} history={history} location={location} />;
    </>
  }

  // =====================================================================
  // BƯỚC 4: RẼ NHÁNH 404 VÀ CHUYỂN HƯỚNG THEO YÊU CẦU
  // =====================================================================
  if (!finalPageConfig) {
      // Không có CẢ data_list_config LẪN listinfo -> lùi về bộ cũ đúng route của nó.
      // (Có listinfo thì đã dựng được cấu hình ở BƯỚC 2B, không rơi vào đây.)
      if (type === "list" || type === "voucher") {
          return (
              <Redirect 
                  to={{ pathname: `/${type}/${code}`, search: location.search, state: location.state }} 
              />
          );
      }

      return (
        <Box sx={{ height: '100dvh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', bgcolor: '#f2f2f7', p: 3 }}>
            <Typography variant="h1" fontWeight="bold" color="text.secondary" sx={{ opacity: 0.5 }}>404</Typography>
            <Typography variant="h6" sx={{ mt: 2, mb: 3 }}>
            Phân hệ "{code}" chưa được cấu hình.
            </Typography>
            <Button variant="contained" startIcon={<ArrowBackIcon />} onClick={() => history.push('/')} sx={{ borderRadius: 3, textTransform: 'none' }}>
            Quay về trang chủ
            </Button>
        </Box>
      );
  }

  // =====================================================================
  // BƯỚC 5: RẼ NHÁNH HIỂN THỊ
  // =====================================================================
  if (type !== "report") {
      //console.log(finalPageConfig);
      finalPageConfig.canAdd = finalPageConfig.canAdd !== false;
      finalPageConfig.canEdit = finalPageConfig.canEdit !== false;
      finalPageConfig.canDelete = finalPageConfig.canDelete !== false;
      if(finalPageConfig.sortOptions?.length==0){
         finalPageConfig.sortOptions = undefined;
      }
      finalPageConfig.condition ={...(finalPageConfig.condition||{}),...(finalPageConfig.conditionScript||{})}
      const mergedCondition = {
        ...(finalPageConfig.defaultCondition || {}),
        ...(finalPageConfig.condition || {}),
        ...stateCondition
      };

      return (
        <>
          <Helmet title={`${finalTitle} - ${context.appInfo?.name || ""}`} />
          <DataListManager 
              key={`page_${finalPageConfig.code || finalPageConfig.moduleCode}`} 
              {...finalPageConfig}
              defaultCondition={mergedCondition}
              containerSx={{borderRadius:0}}
              onBack={() => history.goBack()}
          />
        </>
        
      );
  }

  const mergedCondition = {
      ...(finalPageConfig.defaultCondition || {}),
      ...stateCondition
  };
  // Mở từ widget dashboard: đúng mẫu pivot + điều kiện widget đang hiển thị (áp dụng ngay).
  const moTuDashboard = docTrangThaiMoBaoCao(location.state);
  
  return (
      <>
        <Helmet title={`${finalTitle} - ${context.appInfo?.name || ""}`} />
        <ReportFrame 
            key={`report_${finalPageConfig.code || code}`} 
            {...finalPageConfig} 
            containerSx={{borderRadius:0}}
            defaultCondition={mergedCondition} 
            onBack={() => history.goBack()}
            {...moTuDashboard}
        />
      </>
      
  );
};

// =====================================================================
// BỌC BẰNG REACT.MEMO CHẶN RENDER VÔ ÍCH 
// =====================================================================
const DynamicPage = React.memo(DynamicPageRender, (prevProps, nextProps) => {
  const prevType = prevProps.match?.params?.type;
  const nextType = nextProps.match?.params?.type;
  
  const prevCode = prevProps.match?.params?.code;
  const nextCode = nextProps.match?.params?.code;

  return prevType === nextType && prevCode === nextCode;
});

export default withRouter(DynamicPage);